import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Heart, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-6" data-testid="forgot-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <span className="w-10 h-10 rounded-full bg-[#C1272D] flex items-center justify-center text-white"><Heart size={20} fill="white" /></span>
          <span className="font-display text-2xl font-bold text-[#1F4D2E]">Refugium Ethiopia</span>
        </Link>
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-8 font-admin">
          <h1 className="text-2xl font-bold text-[#0A0A0A] mb-1">Reset your password</h1>
          {sent ? (
            <p className="text-sm text-[#52525B] mt-4" data-testid="forgot-confirmation">If that email is registered, a reset link has been sent. Please check your inbox.</p>
          ) : (
            <>
              <p className="text-sm text-[#52525B] mb-6">Enter your email and we'll send you a reset link.</p>
              {error && <div className="bg-red-50 text-red-700 text-sm rounded-md px-4 py-3 mb-4">{error}</div>}
              <form onSubmit={submit}>
                <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"
                  className="w-full border border-gray-200 rounded-md px-4 py-2.5 mb-5 focus:outline-none focus:ring-2 focus:ring-[#0A0A0A]" placeholder="you@email.com" />
                <button disabled={busy} data-testid="forgot-submit" className="w-full bg-[#0A0A0A] text-white rounded-md px-4 py-3 font-medium hover:bg-gray-800 transition-colors inline-flex items-center justify-center gap-2">{busy ? <Loader2 className="animate-spin" size={18} /> : "Send reset link"}</button>
              </form>
            </>
          )}
          <Link to="/login" className="block text-center text-sm text-[#C1272D] mt-6 hover:underline" data-testid="back-to-signin">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
